import styled from 'styled-components';

export const Container = styled.div`
  scroll-behavior: smooth;
  background: #f2f4f7;
  overflow: hidden;
`;
